import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/construction-data',
    name: 'constructionData',
    component: () => import(/* webpackChunkName: "construction-data" */ '../views/ConstructionData.vue'),
    meta: { fullscreen: true, title: '施工养护综合数据' }
  },
  {
    path: '/electronic-file',
    name: 'electronicFile',
    component: () => import(/* webpackChunkName: "electronic-file" */ '../views/ElectronicFile.vue'),
    meta: { fullscreen: true, title: '机电设备电子档案' }
  },
  {
    path: '/manage-desk',
    name: 'manageDesk',
    component: () => import(/* webpackChunkName: "manage-desk" */ '../views/ManageDesk.vue'),
    meta: { fullscreen: true, title: '机电运维管理台' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
